import { useEffect, useRef, useState } from "react";

export interface UseInViewOptions {
    threshold?: number;
    rootMargin?: string;
    once?: boolean;
}

export function useInView({
    threshold = 0.12,
    rootMargin = "0px 0px -8% 0px",
    once = true,
}: UseInViewOptions = {}) {
    const ref = useRef<HTMLElement | null>(null);
    const [inView, setInView] = useState(false);

    useEffect(() => {
        const node = ref.current;
        if (!node) {
            return;
        }

        if (typeof IntersectionObserver === "undefined") {
            setInView(true);
            return;
        }

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setInView(true);
                    if (once) {
                        observer.disconnect();
                    }
                } else if (!once) {
                    setInView(false);
                }
            },
            { threshold, rootMargin }
        );

        observer.observe(node);
        return () => observer.disconnect();
    }, [threshold, rootMargin, once]);

    return { ref, inView };
}
